/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Content_Form_DescInputs */

const en_directory_submit_content_form_desc = /** @type {(inputs: Directory_Submit_Content_Form_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These are the details editors review and publish with your listing.`)
};

const zh_directory_submit_content_form_desc = /** @type {(inputs: Directory_Submit_Content_Form_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些内容会由编辑审核，并用于发布你的条目。`)
};

/**
* | output |
* | --- |
* | "These are the details editors review and publish with your listing." |
*
* @param {Directory_Submit_Content_Form_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_content_form_desc = /** @type {((inputs?: Directory_Submit_Content_Form_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Content_Form_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_content_form_desc(inputs)
	return zh_directory_submit_content_form_desc(inputs)
});
export { directory_submit_content_form_desc as "directory.submit.content.form_desc" }